export default __webpack_public_path__ + "static/media/f25-banner-mob.bb10ff8e.jpg";